import { defineStore } from 'pinia'
import { cartCount } from "@/api/user.js"

export const useUserStore = defineStore('user', {
	state: () => {
		return { 
			userInfo: {}, // 用户信息
			currentTab: 'home', //选中tabbar
			xShareId: '', //小鹅通分享id
			tyPageId: '355',
			carNum: 0,
			allCartNum: 0,
		}
	},
	actions: {
		setUserInfo(userInfo) {
		  this.userInfo = userInfo
		},
		setTabbar(tabbar) {
			this.currentTab = tabbar;
		},
		catList2Num(list) {
			let num = 0
			list.forEach(item => {
				num += item.num
			})
			this.carNum = parseInt(num.toFixed(0))
		},
		getCartNum() {
			cartCount({
				type: 'sum',
				numType: true
			}).then(res => {
				userState.allCartNum = res.data.count;
			})
		},
		setAllCartNum(count) {
			this.allCartNum = count;
		}
	},
  persist: {
    enabled: true,
    strategies: [{
      key: 'store_user',
      storage: localStorage,
    }]
  }
})

export default useUserStore
